import { request } from '@/shared/api/request'
export const getAid = (page, size, bin, srcText = null, cat = null) =>
	request({
		url: `/contract/aid/all?page=${page}&size=${size}&bin=${bin}${
			srcText && srcText.length ? `&srcText=${srcText}` : ''
		}${cat && cat.length && cat !== 'all' ? `&cat=${cat}` : ''}`,
		method: 'GET',
	})
